<template>
  <div class="s-explanation">
    <SHeading class="s-explanation__title" color="primary" level="2" size="2">
      {{ tr("client.homepage.explanation_how_does_it_work") }}
    </SHeading>
    <div class="s-explanation__steps">
      <div class="s-explanation__step">
        <div class="s-explanation__step-content">
          <i class="fa-light fa-house-chimney s-explanation__step-icon" />
          <p class="s-explanation__step-text">
            {{ tr("client.homepage.explanation_step_one_description") }}
          </p>
        </div>
      </div>
      <div class="s-explanation__step">
        <div class="s-explanation__step-content">
          <i class="fa-light fa-gears s-explanation__step-icon" />
          <p class="s-explanation__step-text">
            {{ tr("client.homepage.explanation_step_two_description") }}
          </p>
        </div>
      </div>
      <div class="s-explanation__step">
        <div class="s-explanation__step-content">
          <i class="fa-light fa-check s-explanation__step-icon" />
          <p class="s-explanation__step-text">
            {{ tr("client.homepage.explanation_step_three_description") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { SHeading } from "@solvari/components";
import { useI18nMainSiteHomepage } from "@solvari/translations";

const { tr } = useI18nMainSiteHomepage();
</script>

<style lang="postcss">
.s-explanation {
  &__title {
    @apply mb-6;
  }

  &__steps {
    @apply flex flex-col;
  }

  &__step {
    @apply flex h-full min-h-36 flex-col justify-center bg-primary-50 px-6;

    &-content {
      @apply flex flex-col;
    }

    &-icon {
      @apply mb-2 text-3xl;
    }

    &-text {
      @apply mb-0;
    }

    &:first-child {
      @apply rounded-t;
      clip-path: polygon(
        0% 0%,
        100% 0,
        100% calc(100% - 2rem),
        50% 100%,
        0 calc(100% - 2rem)
      );

      .s-explanation__step-content {
        @apply pb-10 pt-8;
      }
    }

    &:not(:first-child, :last-child) {
      @apply w-full;
      clip-path: polygon(
        0 0,
        50% 2rem,
        100% 0,
        100% calc(100% - 2rem),
        50% 100%,
        0 calc(100% - 2rem)
      );

      .s-explanation__step-content {
        @apply py-10;
      }
    }

    &:last-child {
      @apply rounded-b;
      clip-path: polygon(50% 2rem, 100% 0, 100% 100%, 0 100%, 0 0);

      .s-explanation__step-content {
        @apply pb-8 pt-10;
      }
    }

    &:not(:first-child) {
      @apply -mt-5;
    }
  }
}

@screen 600 {
  .s-explanation {
    &__step-content {
      @apply items-center;
    }
  }
}

@screen 800 {
  .s-explanation {
    &__steps {
      @apply w-full max-w-screen-1200 flex-row;
    }

    &__step {
      @apply min-h-48 flex-1 px-0;

      &-content {
        @apply items-start px-8;
      }

      &-icon {
        @apply mb-6 text-3xl;
      }

      &-text {
        @apply text-base;
      }

      &:first-child {
        @apply ml-0;
        clip-path: polygon(
          0% 0%,
          calc(100% - 2rem) 0,
          100% 50%,
          calc(100% - 2rem) 100%,
          0% 100%
        );

        .s-explanation__step-content {
          @apply mb-0 py-0;
        }
      }

      &:not(:first-child, :last-child) {
        clip-path: polygon(
          calc(100% - 2rem) 0,
          100% 50%,
          calc(100% - 2rem) 100%,
          0% 100%,
          2rem 50%,
          0% 0
        );

        .s-explanation__step-content {
          @apply py-0 pl-14;
        }
      }

      &:last-child {
        @apply mr-0;
        clip-path: polygon(0 0, 100% 0%, 100% 100%, 0 100%, 2rem 50%);

        .s-explanation__step-content {
          @apply mt-0 py-0 pl-14 pr-6;
        }
      }

      &:not(:first-child) {
        @apply -ml-3 mt-0;
      }
    }
  }
}
</style>
